module.exports = __webpack_public_path__ + "static/img/logz_zr.7d8ee43.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/logz_zr.png
// module id = Qowj
// module chunks = 69